import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { fromUser } from '@mkp/user/state-logged-in/selectors';
import { LoggedInUserEffects } from './user.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fromUser.featureKey, fromUser.reducer),
    EffectsModule.forFeature([LoggedInUserEffects]),
  ],
})
export class LoggedInUserStateModule {}
